module.exports = __webpack_public_path__ + "static/img/vacation-capsule-wardrobe-for-men-800x534.4f82563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/vacation-capsule-wardrobe-for-men-800x534.jpg
// module id = m0hQ
// module chunks = 0